import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Share2,
  MessageCircle,
  Copy,
  Check,
  Heart,
  Users,
  ArrowRight,
  Megaphone,
  Zap,
  Send,
  Globe,
  Smartphone,
  Instagram,
  Facebook,
  Youtube,
  Mail,
  Link2,
  ExternalLink,
  CheckCircle,
} from "lucide-react";

const SITE_URL = "https://cooperfornv.com";
const SHARE_TEXT =
  "I'm supporting Cooper for Governor of Nevada. Real solutions for housing, healthcare, jobs, and accountability. Check out the platform:";

/* ── SVG Icons for platforms without lucide icons ── */
const XIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" />
  </svg>
);

const ThreadsIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.29 3.276-1.06 1.318-2.654 2.045-4.508 2.06h-.032c-1.96-.017-3.56-.783-4.621-2.214-.914-1.232-1.398-2.885-1.398-4.647 0-3.572 2.233-6.168 5.435-6.29h.039c1.705.056 3.064.597 4.039 1.608.436.453.793.98 1.07 1.568.51-.124.98-.19 1.402-.19h.033c1.89.025 3.32.93 4.037 2.55.45 1.017.534 2.27.236 3.622-.814 3.7-4.202 5.89-8.472 5.89l-.138-.001zm-.013-14.392c-2.07.085-3.393 1.78-3.393 4.393 0 1.332.35 2.58 1.012 3.472.721.972 1.82 1.49 3.178 1.501 1.325-.012 2.39-.498 3.166-1.462.6-.746.997-1.755 1.178-3.003a5.574 5.574 0 00-1.842-1.03c-.672-.266-1.42-.414-2.226-.414h-.028c-.078 0-.156.002-.232.006l-.098.003-.002-.106c-.027-1.382-.635-2.428-1.708-2.94a3.61 3.61 0 00-.445-.185 5.146 5.146 0 01.44-.235z" />
  </svg>
);

const SnapchatIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12.922-.215.095-.035.19-.065.275-.089.23-.065.39-.1.54-.1.374 0 .665.206.77.506.126.394-.068.78-.344.937-.13.073-.346.168-.59.27l-.049.022c-.414.182-.992.437-1.108.6-.044.062-.068.136-.068.212 0 .078.015.164.04.26.14.575.646 1.218 1.322 1.835 1.03.943 1.614 1.81 1.614 2.588 0 .163-.026.32-.076.464-.125.36-.396.644-.747.82-.35.175-.748.26-1.148.26-.255 0-.51-.03-.763-.087-.244-.055-.485-.106-.723-.15-.274-.05-.536-.077-.774-.074l-.14.003c-.192.011-.378.074-.546.18-.234.146-.544.526-.878.935l-.085.105c-.396.486-.844 1.038-1.443 1.038-.069 0-.139-.007-.208-.022-.586-.127-1.048-.467-1.468-.78l-.12-.088c-.347-.252-.66-.456-.947-.556a2.35 2.35 0 00-.756-.137c-.343 0-.714.094-1.082.32-.455.281-.797.587-1.073.818l-.046.037c-.282.23-.472.374-.64.374h-.01c-.07 0-.139-.008-.206-.022l-.061-.013c-.483-.104-1.196-.442-1.197-.443a3.81 3.81 0 01-.257-.139c-.283-.17-.52-.343-.622-.504-.114-.18-.165-.29-.165-.428 0-.255.139-.48.498-.741.3-.218.657-.39.977-.538l.022-.01.05-.023c.17-.077.32-.148.445-.213.226-.118.4-.265.484-.39.045-.065.068-.14.068-.213 0-.078-.015-.163-.04-.26-.14-.574-.646-1.218-1.322-1.835-1.03-.943-1.614-1.81-1.614-2.588 0-.163.026-.32.076-.464.125-.36.396-.644.747-.82.35-.175.748-.26 1.148-.26.255 0 .51.03.763.087.244.055.485.106.723.15.274.05.536.077.774.074l.14-.003c.192-.011.378-.074.546-.18.234-.146.544-.526.878-.935l.085-.105c.396-.486.844-1.038 1.443-1.038.069 0 .139.007.208.022.586.127 1.048.467 1.468.78l.12.088c.347.252.66.456.947.556.234.082.49.137.756.137.343 0 .714-.094 1.082-.32.455-.281.797-.587 1.073-.818l.046-.037c.282-.23.472-.374.64-.374h.01z" />
  </svg>
);

/* ── Share platforms ── */
const sharePlatforms = [
  {
    name: "X (Twitter)",
    icon: XIcon,
    color: "bg-black hover:bg-slate-800",
    action: "share",
  },
  {
    name: "Facebook",
    icon: Facebook,
    color: "bg-[#1877F2] hover:bg-[#1565D8]",
    action: "facebook",
  },
  {
    name: "Reddit",
    icon: MessageCircle,
    color: "bg-[#FF4500] hover:bg-[#E03D00]",
    action: "reddit",
  },
  {
    name: "LinkedIn",
    icon: Link2,
    color: "bg-[#0A66C2] hover:bg-[#084E96]",
    action: "linkedin",
  },
  {
    name: "WhatsApp",
    icon: Smartphone,
    color: "bg-[#25D366] hover:bg-[#1DA851]",
    action: "whatsapp",
  },
  {
    name: "Email",
    icon: Mail,
    color: "bg-[#002B7F] hover:bg-[#001F5C]",
    action: "email",
  },
  {
    name: "Nextdoor",
    icon: Users,
    color: "bg-[#8ED500] hover:bg-[#7ABB00] text-black",
    action: "nextdoor",
  },
  {
    name: "Threads",
    icon: ThreadsIcon,
    color: "bg-black hover:bg-slate-800",
    action: "threads",
  },
];

/* ── Follow platforms (placeholder links — user will update later) ── */
const followPlatforms = [
  {
    name: "Facebook",
    icon: Facebook,
    url: "https://www.facebook.com/share/1KjygS1tMb/",
    color: "bg-[#1877F2]",
    desc: "Follow for daily updates and live events",
  },
  {
    name: "Instagram",
    icon: Instagram,
    url: "https://instagram.com/CooperForNV",
    color: "bg-gradient-to-br from-[#833AB4] via-[#FD1D1D] to-[#F77737]",
    desc: "Behind-the-scenes and campaign moments",
  },
  {
    name: "X (Twitter)",
    icon: XIcon,
    url: "https://twitter.com/CooperForNV",
    color: "bg-black",
    desc: "Real-time campaign news and policy updates",
  },
  {
    name: "TikTok",
    icon: TikTokIcon,
    url: "https://tiktok.com/@cooperfornv",
    color: "bg-black",
    desc: "Short-form videos on policy and Nevada issues",
  },
  {
    name: "YouTube",
    icon: Youtube,
    url: "https://youtube.com/@CooperForNV",
    color: "bg-[#FF0000]",
    desc: "Full speeches, town halls, and policy explainers",
  },
  {
    name: "Threads",
    icon: ThreadsIcon,
    url: "https://threads.net/@CooperForNV",
    color: "bg-black",
    desc: "Join the conversation on Threads",
  },
];

const SpreadTheWordPage = () => {
  const [copied, setCopied] = useState(false);

  const shareUrls = {
    share: `https://twitter.com/intent/tweet?text=${encodeURIComponent(SHARE_TEXT)}&url=${encodeURIComponent(SITE_URL)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(SITE_URL)}`,
    email: `mailto:?subject=${encodeURIComponent("Cooper for Governor of Nevada")}&body=${encodeURIComponent(`${SHARE_TEXT}\n\n${SITE_URL}`)}`,
    reddit: `https://www.reddit.com/submit?url=${encodeURIComponent(SITE_URL)}&title=${encodeURIComponent("Cooper for Governor of Nevada")}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(SITE_URL)}`,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(`${SHARE_TEXT} ${SITE_URL}`)}`,
    nextdoor: `https://nextdoor.com/sharekit/?source=Cooper+for+Nevada&body=${encodeURIComponent(`${SHARE_TEXT} ${SITE_URL}`)}`,
    threads: `https://threads.net/intent/post?text=${encodeURIComponent(`${SHARE_TEXT} ${SITE_URL}`)}`,
  };

  const handleShare = (action) => {
    const url = shareUrls[action];
    if (url) window.open(url, "_blank");
  };

  const copyLink = () => {
    navigator.clipboard.writeText(SITE_URL);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <div data-testid="spread-the-word-page" className="bg-[#0B1A3B] pt-16 md:pt-20">
      {/* ── HERO ── */}
      <section className="relative py-16 md:py-28 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B1A3B] via-[#0F2251] to-[#0B1A3B]" />
        <div className="absolute inset-0 opacity-10">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                'url("data:image/svg+xml,%3Csvg width=\'40\' height=\'40\' viewBox=\'0 0 40 40\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M20 20.5V18H0v-2h20v-2l2 3.5-2 3zm0-18V0h20v2H20v2l-2-3.5 2-3z\' fill=\'%23D4AF37\' fill-opacity=\'0.3\'/%3E%3C/svg%3E")',
            }}
          />
        </div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#D4AF37] text-black text-xs font-bold uppercase tracking-[0.2em] mb-6">
            <Megaphone className="w-4 h-4" />
            How You Can Help
          </div>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tighter text-white mb-6 max-w-3xl mx-auto">
            The Most Powerful Way You Can Help Is Simple:{" "}
            <span className="text-[#D4AF37]">Share This Message</span>
          </h1>
          <p className="text-lg text-[#C0C0C0] max-w-2xl mx-auto mb-10">
            If you believe Nevada needs real change, you don't need money or
            experience — you just need to share this with someone you know.
          </p>

          {/* Hero share buttons */}
          <div className="flex flex-wrap justify-center gap-3 mb-10">
            {sharePlatforms.map((p) => {
              const Icon = p.icon;
              return (
                <button
                  key={p.name}
                  onClick={() => handleShare(p.action)}
                  className={`flex items-center justify-center gap-2 px-5 py-3 text-white font-bold uppercase tracking-widest text-xs transition-all hover:-translate-y-1 hover:shadow-xl ${p.color}`}
                >
                  <Icon className="w-4 h-4" />
                  {p.name}
                </button>
              );
            })}
            <button
              onClick={copyLink}
              className={`flex items-center justify-center gap-2 px-5 py-3 font-bold uppercase tracking-widest text-xs transition-all hover:-translate-y-1 hover:shadow-xl ${
                copied
                  ? "bg-emerald-600 text-white"
                  : "bg-[#C0C0C0] text-white hover:bg-[#0F2251]"
              }`}
            >
              {copied ? (
                <Check className="w-4 h-4" />
              ) : (
                <Copy className="w-4 h-4" />
              )}
              {copied ? "Copied!" : "Copy Link"}
            </button>
          </div>

          <div className="bg-[#D4AF37]/20 border-2 border-[#D4AF37]/40 p-6 max-w-2xl mx-auto">
            <p className="text-white font-bold">
              I'm running in the{" "}
              <span className="text-[#D4AF37]">
                Nevada Democratic Primary on June 9th
              </span>{" "}
              — and I need your help getting this message in front of as many
              Nevada voters as possible.
            </p>
          </div>
        </div>
      </section>

      {/* ── POWERED BY YOU ── */}
      <section className="py-16 md:py-24 relative">
        <div className="absolute inset-0 bg-[#0F2251]" />
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-10">
            <Heart className="w-10 h-10 text-[#D4AF37] mx-auto mb-4" />
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
              This Campaign Isn't Powered by Ads — It's Powered by You
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-10">
            <div>
              <p className="text-white/50 leading-relaxed mb-4">
                This campaign is not relying on corporate PACs or billionaire
                donors. There are no Super PACs funding television blitzes. No
                dark money shaping the message.
              </p>
              <p className="text-white/50 leading-relaxed mb-4">
                The strength of this campaign comes from everyday people —
                people like you — who believe Nevada deserves better and are
                willing to say so.
              </p>
              <p className="text-white/50 leading-relaxed">
                Every share is more powerful than a donation, because it comes
                from something money can't buy:{" "}
                <strong className="text-white">trust.</strong>
              </p>
            </div>

            <div className="bg-[#002B7F] p-8 flex items-center">
              <p className="text-white font-bold text-lg leading-relaxed text-center">
                "When you share this with someone, they don't hear it from a
                campaign — they hear it from{" "}
                <span className="text-[#D4AF37]">you</span>."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── WHY SHARING MATTERS ── */}
      <section className="py-16 md:py-24 bg-[#0F2251]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <Share2 className="w-10 h-10 text-white mx-auto mb-4" />
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Why Sharing This Matters More Than Anything Else
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 gap-4 mb-10">
            {[
              {
                icon: Users,
                text: "People trust people they know more than advertisements",
              },
              {
                icon: Globe,
                text: "One share can reach someone who would never see a campaign ad",
              },
              {
                icon: Zap,
                text: "Every post helps reach Nevada voters who are still undecided",
              },
              {
                icon: MessageCircle,
                text: "Momentum comes from conversations, not commercials",
              },
            ].map((item) => {
              const Icon = item.icon;
              return (
                <div
                  key={item.text}
                  className="flex items-start gap-4 bg-[#0F2251] border-2 border-white/10 p-5"
                >
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-[#002B7F] text-white">
                    <Icon className="w-5 h-5" />
                  </div>
                  <p className="text-white/80 font-medium text-sm leading-relaxed">
                    {item.text}
                  </p>
                </div>
              );
            })}
          </div>

          <div className="bg-[#002B7F] p-8 text-center">
            <p className="text-white font-bold text-lg">
              "If you've ever wondered how real change happens — this is how it
              starts."
            </p>
          </div>
        </div>
      </section>

      {/* ── SHARE THE CAMPAIGN ── */}
      <section className="py-16 md:py-24 bg-[#0F2251]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Zap className="w-12 h-12 text-[#D4AF37] mx-auto mb-4" />
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Share the Campaign
          </h2>
          <p className="text-white/50 mb-10 max-w-xl mx-auto">
            Pick a platform. That's all it takes. Even sharing with just one
            person helps more than you think.
          </p>

          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-3 mb-8">
            {sharePlatforms.map((p) => {
              const Icon = p.icon;
              return (
                <button
                  key={p.name}
                  onClick={() => handleShare(p.action)}
                  data-testid={`share-${p.name.toLowerCase().replace(/[^a-z]/g, "")}`}
                  className={`flex items-center gap-3 p-4 text-white font-bold text-sm transition-all hover:-translate-y-1 hover:shadow-xl ${p.color}`}
                >
                  <Icon className="w-5 h-5 flex-shrink-0" />
                  <span>{p.name}</span>
                </button>
              );
            })}
          </div>

          {/* Copy Link Bar */}
          <div className="flex items-center gap-2 max-w-lg mx-auto bg-[#0B1A3B] border-2 border-white/10 p-2">
            <input
              type="text"
              value={SITE_URL}
              readOnly
              className="flex-1 bg-transparent px-4 py-2 text-sm text-white/50 outline-none"
            />
            <button
              onClick={copyLink}
              className={`flex items-center gap-2 px-6 py-3 font-bold uppercase tracking-widest text-sm transition-all ${
                copied
                  ? "bg-emerald-600 text-white"
                  : "bg-[#D4AF37] hover:bg-[#B5952F] text-black"
              }`}
            >
              {copied ? (
                <Check className="w-4 h-4" />
              ) : (
                <Copy className="w-4 h-4" />
              )}
              {copied ? "Copied!" : "Copy"}
            </button>
          </div>
        </div>
      </section>

      {/* ── FOLLOW THE CAMPAIGN ── */}
      <section className="py-16 md:py-24 bg-[#002B7F]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37] text-black mx-auto mb-4">
              <Users className="w-6 h-6" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Follow the Campaign
            </h2>
            <p className="text-[#C0C0C0] max-w-xl mx-auto">
              Stay connected. Get updates. Be part of the movement. Follow
              Cooper for Nevada on every platform.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {followPlatforms.map((p) => {
              const Icon = p.icon;
              return (
                <a
                  key={p.name}
                  href={p.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`follow-${p.name.toLowerCase().replace(/[^a-z]/g, "")}`}
                  className="group bg-[#0F2251]/10 border border-white/20 hover:border-[#D4AF37] p-5 transition-all hover:-translate-y-1"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div
                      className={`w-10 h-10 flex items-center justify-center text-white ${p.color}`}
                    >
                      <Icon className="w-5 h-5" />
                    </div>
                    <div className="flex-1">
                      <p className="font-bold text-white text-sm">{p.name}</p>
                    </div>
                    <ExternalLink className="w-4 h-4 text-white/30 group-hover:text-[#D4AF37] transition-colors" />
                  </div>
                  <p className="text-white/60 text-xs leading-relaxed">
                    {p.desc}
                  </p>
                </a>
              );
            })}
          </div>
        </div>
      </section>

      {/* ── REACH EVERY CORNER ── */}
      <section className="py-16 md:py-24 bg-[#0F2251]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Globe className="w-10 h-10 text-white mx-auto mb-4" />
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Help This Message Reach Every Corner of Nevada
          </h2>
          <p className="text-white/50 max-w-2xl mx-auto mb-8">
            The goal is to reach voters across cities, suburbs, and rural areas
            — especially people who feel like politics hasn't worked for them.
          </p>

          <div className="grid md:grid-cols-3 gap-4 mb-8">
            {[
              {
                title: "Las Vegas & Henderson",
                desc: "Reach urban families dealing with housing costs and healthcare access",
              },
              {
                title: "Reno & Sparks",
                desc: "Connect with workers and families in Northern Nevada's growing communities",
              },
              {
                title: "Rural Nevada",
                desc: "Reach voters in communities often ignored by traditional campaigns",
              },
            ].map((item) => (
              <div
                key={item.title}
                className="bg-[#002B7F] p-6 text-left"
              >
                <h3 className="font-bold text-[#D4AF37] text-sm mb-2">
                  {item.title}
                </h3>
                <p className="text-white/70 text-xs leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          <div className="bg-white/5 border-2 border-white/15 p-6">
            <p className="text-white font-bold">
              "If you know someone in Nevada who wants real change, this is how
              you reach them."
            </p>
          </div>
        </div>
      </section>

      {/* ── DONATIONS SECTION ── */}
      <section className="py-16 md:py-24 bg-[#C0C0C0]/10">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Donations Help — But They're Not the Most Important Thing
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-4 mb-8">
            {[
              {
                title: "Donations fund outreach",
                desc: "They help with visibility, printing, and events",
              },
              {
                title: "Sharing builds momentum",
                desc: "Your voice carries more weight than any ad",
              },
              {
                title: "Everyone can contribute",
                desc: "Even without giving a dollar, you can be a key part of this campaign",
              },
            ].map((item) => (
              <div
                key={item.title}
                className="bg-[#0F2251] border-2 border-white/10 p-5"
              >
                <h3 className="font-bold text-white text-sm mb-2">
                  {item.title}
                </h3>
                <p className="text-white/50 text-xs leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          <div className="bg-[#D4AF37]/15 border-2 border-[#D4AF37]/30 p-6 text-center">
            <p className="text-white font-bold">
              You are not just supporting this campaign — you are how other
              people find out about it.
            </p>
          </div>
        </div>
      </section>

      {/* ── HOW TO VOTE IN THE DEMOCRATIC PRIMARY ── */}
      <section className="py-16 md:py-24 bg-[#0F2251]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <div className="w-12 h-12 flex items-center justify-center bg-[#002B7F] text-white mx-auto mb-4">
              <CheckCircle className="w-6 h-6" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
              How to Vote in the Democratic Primary
            </h2>
            <p className="text-white/50 max-w-2xl mx-auto">
              In Nevada, you must be registered as a Democrat to vote in the
              Democratic primary. Registering or switching parties is quick and
              easy.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-5 mb-8">
            {/* 1. Not Registered */}
            <div className="bg-[#0F2251] border-2 border-white/10 p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center bg-[#D4AF37] text-black font-black text-sm">
                  1
                </div>
                <h3 className="font-bold text-white">Not Registered?</h3>
              </div>
              <p className="text-white/50 text-sm leading-relaxed mb-4">
                You can register online in minutes. Just select{" "}
                <strong>"Democratic Party"</strong> when you register.
              </p>
              <a
                href="https://www.nvsos.gov/sosvoterservices/registration/Step0.aspx"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="register-to-vote-btn"
                className="inline-flex items-center gap-2 px-6 py-3 bg-[#D4AF37] hover:bg-[#B5952F] text-black font-bold uppercase tracking-widest text-xs transition-all hover:-translate-y-0.5 hover:shadow-lg"
              >
                <ExternalLink className="w-4 h-4" />
                Register to Vote
              </a>
            </div>

            {/* 2. Switch Party */}
            <div className="bg-[#0F2251] border-2 border-white/10 p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center bg-[#D4AF37] text-black font-black text-sm">
                  2
                </div>
                <h3 className="font-bold text-white">
                  Already Registered? Switch Your Party
                </h3>
              </div>
              <p className="text-white/50 text-sm leading-relaxed mb-4">
                If you're registered as nonpartisan, independent, or another
                party, you can update your affiliation in just a few minutes
                online.
              </p>
              <a
                href="https://www.nvsos.gov/sosvoterservices/registration/Step0.aspx"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="update-registration-btn"
                className="inline-flex items-center gap-2 px-6 py-3 bg-[#002B7F] hover:bg-[#001F5C] text-white font-bold uppercase tracking-widest text-xs transition-all hover:-translate-y-0.5 hover:shadow-lg"
              >
                <ExternalLink className="w-4 h-4" />
                Update My Registration
              </a>
            </div>

            {/* 3. Same-Day Registration */}
            <div className="bg-[#0F2251] border-2 border-white/10 p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center bg-[#D4AF37] text-black font-black text-sm">
                  3
                </div>
                <h3 className="font-bold text-white">
                  Missed the Deadline? You Can Still Vote
                </h3>
              </div>
              <p className="text-white/50 text-sm leading-relaxed">
                Nevada offers{" "}
                <strong>same-day registration</strong> during early voting and
                on Election Day. You can register or switch parties and vote at
                the same time. Bring a valid ID (and proof of address if
                needed).
              </p>
            </div>

            {/* 4. DMV Option */}
            <div className="bg-[#0F2251] border-2 border-white/10 p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center bg-[#D4AF37] text-black font-black text-sm">
                  4
                </div>
                <h3 className="font-bold text-white">DMV Option</h3>
              </div>
              <p className="text-white/50 text-sm leading-relaxed">
                When visiting the DMV, you can register to vote or update your
                party affiliation at the same time. Just ask when you're there.
              </p>
            </div>
          </div>

          {/* Key Reminder */}
          <div className="bg-[#D4AF37]/15 border-2 border-[#D4AF37]/40 p-5 mb-6">
            <p className="text-white font-bold text-sm text-center">
              Key Reminder: You must be registered as a Democrat to vote in the
              Democratic primary, but you can change your party at any time.
            </p>
          </div>

          <div className="bg-[#002B7F] p-6 text-center">
            <p className="text-white font-bold">
              "Take a minute — register, update your party, and make your voice
              heard."
            </p>
          </div>
        </div>
      </section>

      {/* ── CLOSING ── */}
      <section className="py-16 md:py-24 bg-[#0F2251]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-6">
            This Campaign Belongs to You
          </h2>
          <p className="text-lg text-white/50 leading-relaxed mb-4">
            I'm running in the{" "}
            <strong className="text-white">
              Nevada Democratic Primary on June 9th
            </strong>{" "}
            because I believe you deserve a real voice in your future.
          </p>
          <p className="text-lg text-white/50 leading-relaxed mb-4">
            Not tomorrow. Not someday.{" "}
            <strong className="text-[#D4AF37]">Right now.</strong>
          </p>
          <p className="text-lg text-slate-700 leading-relaxed font-medium">
            And the fastest way to make that happen is simple — share this with
            someone who needs to hear it.
          </p>
        </div>
      </section>

      {/* ── FINAL CTA ── */}
      <section className="py-16 md:py-24 bg-[#002B7F]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Share the Message. Change the Future.
          </h2>
          <p className="text-[#C0C0C0] mb-8">
            Every share brings Nevada one step closer to real change.
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-8">
            {sharePlatforms.slice(0, 4).map((p) => {
              const Icon = p.icon;
              return (
                <button
                  key={p.name}
                  onClick={() => handleShare(p.action)}
                  className={`flex items-center gap-2 px-5 py-3 text-white font-bold uppercase tracking-widest text-xs transition-all hover:-translate-y-1 hover:shadow-xl ${p.color}`}
                >
                  <Icon className="w-4 h-4" />
                  {p.name}
                </button>
              );
            })}
            <button
              onClick={copyLink}
              className={`flex items-center gap-2 px-5 py-3 font-bold uppercase tracking-widest text-xs transition-all hover:-translate-y-1 hover:shadow-xl ${
                copied
                  ? "bg-emerald-600 text-white"
                  : "bg-[#C0C0C0] text-white hover:bg-[#0F2251]"
              }`}
            >
              {copied ? (
                <Check className="w-4 h-4" />
              ) : (
                <Copy className="w-4 h-4" />
              )}
              {copied ? "Copied!" : "Copy Link"}
            </button>
          </div>

          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/volunteer"
              className="inline-flex items-center gap-2 px-8 py-4 border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black font-bold uppercase tracking-widest text-sm transition-all"
            >
              Volunteer
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-8 py-4 border-2 border-white/40 text-white/80 hover:border-white hover:text-white font-bold uppercase tracking-widest text-sm transition-all"
            >
              Contact the Campaign
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SpreadTheWordPage;
